import React from "react";
import HealthIcon from "../../../images/icons/color/health.svg";
import DogIcon from "../../../images/icons/color/personality-trait.svg";
import LifetimeIcon from "../../../images/icons/color/lifetime-trait.svg";
import LabelAndStars from "../LabelAndStars";
import Image from "next/image";

export type ITraitType = `health` | `personality` | `lifetime-care`;
export const traitMap: Record<ITraitType, { text: string; icon: JSX.Element }> = {
    health: {
        text: `Health`,
        icon: (
            <Image
                src={HealthIcon}
                alt=""
                style={{
                    maxWidth: "100%",
                    height: "auto"
                }}
            />
        )
    },
    personality: {
        text: `Personality`,
        icon: (
            <Image
                src={DogIcon}
                alt=""
                style={{
                    maxWidth: "100%",
                    height: "auto"
                }}
            />
        )
    },
    "lifetime-care": {
        text: `Lifetime Care`,
        icon: (
            <Image
                src={LifetimeIcon}
                alt=""
                style={{
                    maxWidth: "100%",
                    height: "auto"
                }}
            />
        )
    }
};

const BreedDetailHeader = ({ trait, starCount }: { trait: ITraitType; starCount: 1 | 2 | 3 | 4 | 5 }) => {
    return (
        <div className="BreedDetailHeader flex items-center gap-4">
            <div className="BreedDetailHeader-icon">{traitMap[trait].icon}</div>
            <div className="BreedDetailHeader-content items-center md:flex md:gap-4">
                <h2 className="BreedDetailHeader-trait mb-1 text-md !font-bold tracking-md text-text-primary lg:text-xl lg:tracking-xl">{traitMap[trait].text}</h2>

                <LabelAndStars starCount={starCount} />
            </div>
        </div>
    );
};

export default BreedDetailHeader;
